// OS notification when a live-polled run finishes. Active only on pages that
// render #live-poller (the run detail page while a run is in progress).
function watchLiveRun() {
  const poller = document.getElementById("live-poller");
  if (!poller) return;
  if (!("Notification" in window)) return;

  // Only prompt when the user has not already decided. Re-prompting a
  // user who previously granted or denied permission is pointless, and a
  // bare requestPermission() call on every active-run page load surfaces
  // the browser dialog repeatedly.
  if (Notification.permission === "default") {
    Notification.requestPermission();
  }

  document.body.addEventListener("htmx:afterRequest", (evt) => {
    const xhr = evt.detail?.xhr;
    if (!xhr) return;
    // Guard on the live-poll endpoint: HX-Refresh is only set there
    // today, but scoping the listener keeps an unrelated future
    // HX-Refresh response from firing a spurious notification.
    const requestPath = evt.detail.requestConfig?.path || "";
    if (requestPath.indexOf("/_live") === -1) return;
    if (xhr.getResponseHeader("HX-Refresh") !== "true") return;
    if (Notification.permission !== "granted") return;

    const runStatus = xhr.getResponseHeader("X-Run-Status") || "";
    const livePoller = document.getElementById("live-poller");
    const targetUrl = livePoller?.dataset.targetUrl || "";
    const runId = livePoller?.dataset.runId || "";

    const title = runStatus === "failed" ? "Run failed" : "Run completed";
    const notification = new Notification(title, { body: targetUrl || "View run details" });

    // Clicking the OS notification focuses the tab and navigates back to
    // the run it reports on.
    if (runId) {
      notification.onclick = () => {
        window.focus();
        window.location.href = `/runs/${runId}`;
        notification.close();
      };
    }
  });
}

watchLiveRun();
